module.exports = __webpack_public_path__ + "img/ceramic-purple.30c11ffe.webp";